import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import type { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import { capitalize } from "@/Helpers/capitalize";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";

export function locationsErrorMessageForNotes(
  notes: string,
  accessorials: Array<string>,
  _locationType: LocationType,
  context: LocationContext,
  onModify: () => void,
): ErrorMessageType {
  function generateErrorMessage() {
    if (!accessorials.includes("LOGISTICS_LIFT_GATE_REQUIRED")) {
      if (
        notes.toLowerCase().includes("liftgate") ||
        notes.toLowerCase().includes("lift gate") ||
        notes.toLowerCase().includes("tailgate") ||
        notes.toLowerCase().includes("tail gate")
      ) {
        return "Lift Gate mentioned, but was not requested in the quote.";
      }
    }

    if (!accessorials.includes("LOGISTICS_INSIDE")) {
      if (notes.toLowerCase().includes("inside")) {
        return `Inside ${capitalize(
          context,
        )} mentioned, but was not requested in the quote.`;
      }
    }

    if (context === LocationContext.Delivery) {
      // CS: Oct 2022
      // We also sometimes have folks write something like 'call ahead', which sometimes triggers
      // 'delivery notification' accessorials with some carriers. eg. ABF. Some carriers will
      // honour it fine without charge.
      // I don't think we have a good way to explain that to the user. So we're deciding just to absorb
      // the cost of those. We can increase the rates for someone who does it consistently to cover the expense.
      if (!accessorials.includes("SCHEDULING_APPOINTMENT_REQUIRED")) {
        if (
          notes.toLowerCase().includes("appointment") ||
          notes.toLowerCase().includes("apptment") ||
          notes.toLowerCase().includes("appt")
        ) {
          return `${capitalize(context)} Appointment mentioned, but was
                        not requested in the quote.`;
        }
      }
    }

    return undefined;
  }

  const errorMessage = generateErrorMessage();

  if (errorMessage !== undefined) {
    // The colour and size come from whatever renders this — FormItem paints an
    // error in small red text — so the link only has to say it is the danger
    // tone and inherit the surrounding type.
    return (
      <Row gap={1}>
        {errorMessage}
        <Button size="link" tone="danger" inheritFont onClick={onModify}>
          Modify quote
        </Button>
      </Row>
    );
  } else {
    return undefined;
  }
}
